import { Element, useNode } from "@craftjs/core";
import StepIntro from "./components/Intro";
import StepTitle from "./components/Title";

interface StepHeaderProps {
    step?: string;
}

const StepHeader = ({ step }: StepHeaderProps) => {
    const {
        connectors: { connect },
    } = useNode();

    return (
        <section id="page-hero" className="relative pt-[60px] mb-1" ref={(ref) => connect(ref!)}>
            <div className="container relative mx-auto 2xl:px-[108px] z-[1]mt-10">
                <h1 className="flex content-center gap-3 items-center">
                    <span className="rounded-full bg-primary-500 text-white w-14 h-14 text-4xl inline-flex items-center justify-center">
                        {step}
                    </span>
                    <Element id="step-title" is={StepTitle} text="Spécifier les exigences" />
                </h1>
                <Element
                    id="step-intro"
                    is={StepIntro}
                    text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at nulla et, imperdiet molestie nibh. Vestibulum mollis viverra odio vitae sodales. Praesent eu pretium purus. Suspendisse potenti. Pellentesque posuere iaculis tempus."
                />
            </div>
        </section>
    );
};

StepHeader.craft = {
    displayName: "Header",
    rules: {
        canDrag: () => false,
        canMoveOut: () => false,
    },
    custom: {
        canDelete: false,
    },
};

export default StepHeader;
